export default __webpack_public_path__ + "static/media/124.27ebd2de.webp";